import React from "react";
import { Link } from "react-router-dom";
import { FaAngleDown } from "react-icons/fa";
import { slugify } from "../../utils";
import ServiceData from "../../data/service/ServiceMain.json";
import EducationData from "../../data/education/EducationMain.json";

const AllData = ServiceData;
const EduData = EducationData;

const Nav = ({ itemShow }) => {
  return (
    <nav className="mainmenu-nav">
      <ul className="mainmenu">
        <li className="menu-item-has-children">
          <Link to="#">
            Services <FaAngleDown />
          </Link>
          <ul className="axil-submenu">
            {AllData.slice(0, itemShow).map((data, index) => (
              <li key={index}>
                <Link
                  to={
                    process.env.PUBLIC_URL +
                    `/service-details/${slugify(data.title)}`
                  }
                >
                  {data.title}
                </Link>
              </li>
            ))}
          </ul>
        </li>
        <li className="menu-item-has-children">
          <Link to="#">
            Products <FaAngleDown />
          </Link>
          <ul className="axil-submenu">
            <li>
              <a href="/securitysoftware/index.html">Security Solutions</a>
            </li>
            <li>
              <a href="/cybersecuritysolutions">Cyber Security Solutions</a>
            </li>
          </ul>
        </li>
        <li className="menu-item-has-children">
          <Link to="#">
            Pages <FaAngleDown />
          </Link>
          <ul className="axil-submenu">
            <li>
              <Link to={process.env.PUBLIC_URL + "/about-us"}>About Us</Link>
            </li>
            <li>
              <Link to={process.env.PUBLIC_URL + "/industries"}>
                Industries
              </Link>
            </li>
            <li>
              <Link to={process.env.PUBLIC_URL + "/hire-resources"}>
                Hire Resources
              </Link>
            </li>
            <li>
              <Link to={process.env.PUBLIC_URL + "/our-office"}>
                Our Office
              </Link>
            </li>
            <li>
              <Link to={process.env.PUBLIC_URL + "/team"}>Team</Link>
            </li>
            {/* <li><Link to={process.env.PUBLIC_URL + "/case-study"}>Case Study</Link></li> */}
            {/* <li><Link to={process.env.PUBLIC_URL + "/case-details/whitehorse"}>Case Study Details</Link></li> */}
            {/* <li><Link to={process.env.PUBLIC_URL + "/team-details/jane-cooper"}>Team Details</Link></li> */}
            {/* <li><Link to={process.env.PUBLIC_URL + "/testimonials"}>Testimonial</Link></li> */}
            {/* <li><Link to={process.env.PUBLIC_URL + "/pricing-table"}>Pricing Table</Link></li> */}
          </ul>
        </li>
        {/* <li className="menu-item-has-children">
                    <Link to="#">Blog <FaAngleDown /></Link>
                    <ul className="axil-submenu">
                        <li><Link to={process.env.PUBLIC_URL + "/blog-grid"}>Blog</Link></li>
                        <li><Link to={process.env.PUBLIC_URL + "/blog-details/1"}>Standard Post</Link></li>
                        <li><Link to={process.env.PUBLIC_URL + "/blog-details/2"}>Gallery Post</Link></li>
                        <li><Link to={process.env.PUBLIC_URL + "/blog-details/3"}>Video Post</Link></li>
                        <li><Link to={process.env.PUBLIC_URL + "#"}>Audio Post</Link></li>
                        <li><Link to={process.env.PUBLIC_URL + "#"}>Quote Post</Link></li>
                    </ul>
                </li> */}

        {/* <li><Link to={process.env.PUBLIC_URL + "/cybersecurity"}>Cyber Security</Link></li> */}
        <li className="menu-item-has-children">
          <Link to={process.env.PUBLIC_URL + "/education"}>
            Education
          </Link>
        </li>
        <li>
          <Link to={process.env.PUBLIC_URL + "/contact"}>Contact</Link>
        </li>
      </ul>
    </nav>
  );
};

export default Nav;
